import React from "react";
import { useRootAppStore } from "@hooks";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default function ChatMinimizeButton() {
	const { chatViewStore } = useRootAppStore();

	const minimizeChatWindow = () => {
		chatViewStore.toggleChatBox(false);
	};

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/ChatMinimizeButton.tsx"}
		>
			<button
				className="chat__btn--mini btn btn--square btn--square--xsml btn--icon btn--primary--inverted"
				onClick={minimizeChatWindow}
			>
				<i className="u-icon u-icon--tny u-icon--minimize u-color--text--primary" />
			</button>
		</ErrorBoundaryWithPropagation>
	);
}
